import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import BaseApi from '@/core/HttpResources/BaseApi';

export default class MemberTypeService {
  private client: BaseHttpClient;
  constructor(public controller: string = "MemberTypes") {
    this.client = new BaseHttpClient(controller);
  }

  public async getAll() {
    try {
      var result = await this.client.getAsync<any>();
      return result;
    } catch (error) {
      throw error;
    }
  }
  GetPrincipalInvestigator() {
    var baseApi = new BaseApi("MemberTypes/GetPrincipalInvestigator");
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async getById(id: number) {
    var baseApi = new BaseApi("MemberTypes/" + id);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}
